import React from 'react';
import Modal from './Modal';

interface ChatDisclaimerModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChatDisclaimerModal: React.FC<ChatDisclaimerModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} title="Notice" onClose={onClose}>
      <div className="disclaimer-modal-content">
        <div className="disclaimer-text">
          <p><strong>NOTICE:</strong> The AI chatbots can provide general health knowledge, educational information, and wellness advice based on established health principles. However, they are NOT a substitute for professional medical advice, diagnosis, or treatment from qualified healthcare providers.</p>
          
          <div className="disclaimer-details">
            <h4>What AI chatbots CAN provide:</h4>
            <ul>
              <li>General health education and information</li>
              <li>Wellness tips and lifestyle advice</li>
              <li>General knowledge about health conditions</li>
              <li>Educational content about nutrition, fitness, and mental health</li>
            </ul>

            <h4>What AI chatbots CANNOT provide:</h4>
            <ul>
              <li>Medical diagnosis or treatment recommendations</li>
              <li>Prescription advice or medication recommendations</li>
              <li>Specific medical interventions</li>
              <li>Professional medical consultation</li>
            </ul>
          </div>

          <div className="disclaimer-footer">
            <p><strong>Always consult qualified healthcare professionals for medical advice, diagnosis, and treatment. In case of medical emergency, contact emergency services immediately.</strong></p>
          </div>
        </div>
        
        <div className="disclaimer-modal-actions">
          <button className="btn btn-primary" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ChatDisclaimerModal;

